import { useEffect, useState } from 'react'
import { observer } from 'mobx-react';

import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import ProgressLoader from '../../progressLoader';
import SiteAssetsDetail from './siteAssetsDetail';
import SiteProjectsDetail from './siteProjectsDetail';
import DetailCellRenderer from '../../../views/catalogue/SiteList/components/SiteDetailsRowRenderer';



const SiteDetails = (props: any) => {
    const siteId = props.data.siteId;
    const [isLoading, setIsLoading] = useState(false);
 


    useEffect(() => {
        props.assetStore.getAssetsBySiteId(siteId);
     
    }, []);
   
    return (
        <><Box margin={3} height={450}>
            {isLoading ? (
                <ProgressLoader />
            ) : (

                <Tabs variant='enclosed' isLazy >
                    <TabList >
                        <Tab>Detail</Tab>
                        <Tab>Assets</Tab>
                        <Tab>Site Locations</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel >

                         

                            <DetailCellRenderer rowData={props.data} />
                            {/* <ProjectLinkedItemsView ProjectStore={props.projectStore} ProjectItems={ProjectItems} currentUserId={props.currentUser.uid} ProjectId={props.data.vtProjectFsid} /> */}

                        </TabPanel>

                        <TabPanel >

                        <SiteAssetsDetail AssetStore={props.assetStore} />
                            {/* <ProjectSharedProjectsView ProjectStore={props.projectStore} SharedProjects={SharedProjectItems} currentUserId={props.currentUser.uid} ProjectId={props.data.vtProjectFsid} /> */}
                        </TabPanel>
                        <TabPanel >
                        <SiteProjectsDetail AssetStore={props.assetStore} />
                            {/* <ProjectAuditItemsView AuditItems={AuditItems} /> */}
                        </TabPanel>
                    </TabPanels>
                </Tabs>

            )}

        </Box>


























        </>)
}

export default observer(SiteDetails)